import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
    box: {
        backgroundColor: '#254a8e',
        flex: 1,
        maxWidth: '100%',
        overflow: 'visible',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        '& *': {
            color: '#FFFFFF'
        }
    },
    image: {
        maxWidth: '80%'
    },
    stateText: {
        textAlign: 'center',
        paddingTop: '3vh',
        color: '#ccc',
        maxWidth: '80%',
        overflowWrap: 'break-word'
    }
}));

const AuthenticationStatusPage = ({ children }) => {
    const classes = useStyles();

    return (
        <Box className={classes.box}>
            <img
                className={classes.image}
                alt="Logo"
                src="/images/smartdialog_logo.png"
            />
            {typeof children === 'string' && (
                <Typography
                    gutterBottom
                    variant="h3"
                    className={classes.stateText}
                >
                    {children}
                </Typography>
            )}
            {typeof children !== 'string' && children}
        </Box>
    );
};

AuthenticationStatusPage.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default AuthenticationStatusPage;
